import Vue from 'vue';
import colors from 'vuetify/lib/util/colors';
import { Module } from 'vuex';
import { axios } from '@/plugins/http-axios';

interface IDataColor {
  [key: string]: string;
}

interface IColorState {
  color: IDataColor;
  applied: boolean;
}

export default <Module<IColorState, any>>{
  state: {
    color: {},
    applied: false,
  },
  mutations: {
    setColor(state, data: IDataColor) {
      state.color = data;
    },
    setColorApplied(state, status = false) {
      state.applied = status;
    },
  },
  actions: {
    async getColor({ commit, dispatch, rootGetters }): Promise<void> {
      return axios
        .get<IDataColor>(rootGetters.uri.color)
        .then((resp) => {
          commit('setColor', resp.data);
          return Promise.resolve();
        })
        .catch((e) => {
          e.uri = rootGetters.uri.color;
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    setTheme({ state, commit, getters }) {
      if (state.color.applied) return;

      Vue.prototype.$vuetify.framework.theme.themes.light = {
        secondary: colors.red.lighten4, // #FFCDD2

        fieldStepperColor: getters.color.BG_COLOR_FIELD || '#fff', // Цвет подложек
        navbarColor: getters.color.BG_COLOR_LEFT_PANEL || '#2C4C57', // Боковое меню
        background: getters.color.BG_COLOR_MAIN || '#F3F4F6', // Основной цвет фона в лкк
        primary: getters.color.PRIMARY_COLOR || '#3FB5EF', // Основной цвет
        error: getters.color.ERROR_COLOR || '#ff0d00',  // цвет отрицания
        success: getters.color.SUCCESS_COLOR || '#4caf50', // цвет подтверждения
        loginPanelColor: getters.color.BG_COLOR_LOGIN_FIELD || '#263B46',  // Фон карточки авторизации
        backgroundLoginColor: getters.color.BG_COLOR_LOGIN || '#2c4c57', // Фон страницы авторизации
        requiredColor: getters.color.REQUIRED_COLOR || '#FF6D12' // Цвет обязательных элементов
      };

      commit('setColorApplied', false);
    },
  },
  getters: {
    color: (state): IDataColor => state.color,
    theme: (): IDataColor => Vue.prototype.$vuetify.framework.theme.themes['light'],
    logoLoginImgW: (state, getters): string => getters.color.LOGO_IMAGE_WIDTH,
    logoLoginImgH: (state, getters): string => getters.color.LOGO_IMAGE_HEIGHT,
    headerLogoImgW: (state, getters): string => getters.color.HEADER_IMG_WIDTH,
    headerLogoImgH: (state, getters): string => getters.color.HEADER_IMG_HEIGHT,
    animationsEnable: (state, getters): string => getters.color.ANIMATION_ENABLE,
    horizontalIndentation: (state, getters): string => getters.color.HORIZONTAL_INDENTATION,
    verticalIndentation: (state, getters): string => getters.color.VERTICAL_INDENTATION,
    dialogWhiteTextEnable: (state, getters): boolean => getters.color.DIALOG_COLOR_TEXT_WHITE === 'true',
  },
};
